import {cs}                from "@Common/react/chain-services";
import {scopedState}       from "@Common/react/scoped-state";
import {UseState}          from "@Common/react/use-state";
import {setCurrentToSaved} from "@Common/ui-components/heavy/item-options/modules/set-current-to-saved";
import {changeNestedValue} from "@Common/utils/arr-path";
import {chain}             from "@Common/utils/fs";
import {omit}              from "@Common/utils/objects";
import {isOiaItem} from "@Common/logic/item/is-oia-item";

export const ListingTypeLogic = (
    {
        item,
        templateOptions,
        next: rootNext,
    }
) => cs(

    ["state", (_, next) => UseState({
        getInitValue: () => chain(
            item?.programData?.listingType,
            (_) => ({
                saved  : _,
                current: _,
            }),
        ),
        next,
    })],
    ["step1", ({}, next) => rootNext({
        cleanItem: (item) => changeNestedValue(item, ["programData"], (_) => omit(_, ["listingType"])),
        next,
    })],
    ({state, step1}) => step1.next(cs(

        ({}, next) => ["mailing", "shipping", "pickup"].includes(step1.method) && next(),
        ({}, next) => (templateOptions.proofEngineType !== 0 && (!item || !isOiaItem(item))) ? null : next(),

        ["listingTypeLabel", (_, next) => next(templateOptions?.programData?.field65Label ?? "")],
        ["listingTypeOptions", (_, next) => next(templateOptions?.programData?.field65Options.replaceAll(/\[|\]|\"+/g, "").split(",") ?? [])],
        ["calSelected", ({listingTypeOptions}, next) => next(
            state.value.current ?? listingTypeOptions[0] ?? ""
        )],

        ({calSelected, listingTypeLabel, listingTypeOptions}) => ({
            itemEditor: {
                $name: "listing type",
                prepareSave: (item) => ({
                    newValue: changeNestedValue(item, ["programData", "listingType"], (_) => calSelected || ""),
                    onSaved: () => setCurrentToSaved(state),
                }),

                changed: state.value.saved !== state.value.current,
                valid: true,
            },
            ui: (listingTypeOptions[0]) && {
                listingTypeLabel, listingTypeOptions,
                calSelected,
                state: scopedState(state, ["current"]),
            },
        }),
    )),
);